import React, {useState,useRef} from 'react'
import {localestr,load} from '../utils'


function TimeKeeping({setModal}){
    const [info, setInfo] = useState(null) 
    const [old, setOld] = useState(null) 
    const targetRef = useRef()
    let bufer=''
    let buf_tm=null

    const newKey=(e)=>{
        if(e.key==='Enter' || e.which===13) {
            if(!bufer) return
            if(bufer===old) return
            setInfo(1)
            load('action=getTimeInfo&data='+bufer,setInfo)
            setOld(bufer)
            setTimeout(() => setOld(null), 20000)
            bufer=''
            if(buf_tm) clearTimeout(buf_tm)
                buf_tm=null
            return
        }
        bufer+=e.key
        if(!buf_tm) buf_tm=setTimeout(() => bufer='', 1000)
    }

    const setFocus=(el)=>{
        if (!el) return
        el.focus()
    }

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWndPay')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function time_to_str(d,timezoneOffset=0){
        let t=parseInt(d||0)||0
        if(!t) return ''
        else t-=timezoneOffset
        let hr=parseInt(t/60)
        let mn=t-hr*60
        if(hr>99) return ''+hr+':'+('00'+mn).slice(-2)
        return ('00'+hr).slice(-2)+':'+('00'+mn).slice(-2)
    }

    let cont=null
    if(!info){
        cont=localestr('Відскануйте бейджик (картку, перепустку...)')
    } else if(info===1){
        cont=localestr('Перевірка ...')
    } else if(info.status==='error'){
        setTimeout(()=>{if(info.status==='error') setInfo(null)}, 60000)
        cont=info.msg
    } else if(info.status==='Ok'){
        //const timezoneOffset = (new Date()).getTimezoneOffset()
        //cont=info.name+"\n"+localestr('Початок ')+time_to_str(info.start,timezoneOffset)
        cont=<span style={{color:'#0000AA'}}>{info.name+', '+localestr('привіт! ')}</span>
        //if(info.is_exit) cont+="\n"+localestr('Закінчення ')+time_to_str(info.finish>1440?info.finish-1440:info.finish,timezoneOffset)+"\n"+localestr('Відпрацьовано ')+time_to_str(info.finish-info.start)
        if(info.is_exit) cont=<span style={{color:'#00AA00'}}>{info.name+', '+localestr('ви зробили це!')+"\n"+localestr('Відпрацьовано ')+time_to_str(info.finish-info.start)}</span>
        }



    return(
        <div className='modal'><div id={'modalWndPay'} className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{localestr('Табелювання')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content' tabIndex='0' style={{width:'350px',height:'220px',outline:'none',display:'flex',flexDirection:'column'}} ref={el=>{setFocus(el);return targetRef}} onKeyUp={(e)=>{newKey(e)}}>
            <div style={{width:'100%',height:'100%',fontSize:'24px',textAlign:'center',display:'flex',justifyContent:'center',alignItems:'center',whiteSpace:'pre-wrap'}}>{cont}</div>
            <div style={{margin:'10px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center',flexWrap:'wrap'}}>
                <div style={{flexDirection:'row',display:'flex',justifyContent:'center'}}>
                <div style={{width:'120px',margin:'0',borderRadius:'20px'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>{setModal('')}}><div>{localestr('Закрити')}</div></div>
                </div>
            </div></div>
        </div></div>
    )
}

export default TimeKeeping